import { Injectable } from '@angular/core';
import { KeyboardState } from '@core/models/KeyboardState';
import { Store, StoreConfig } from '@datorama/akita';

export interface UiState {
    key: string;
    showLoader: boolean;
    showSkeleton: boolean;
    showManualLoader: boolean;
    labelsLoaded: boolean;
    keyboardState: KeyboardState
}

export function createInitialState(): UiState {
    return {
        key: '',
        showLoader: false,
        showManualLoader: false,
        showSkeleton: false,
        labelsLoaded: false,
        keyboardState: KeyboardState.KeyboardDidHide
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'ui' })
export class UiStore extends Store<UiState> {

    constructor() {
        super(createInitialState());
    }

}
